import jsonStringifySafe from 'json-stringify-safe'

export default function getSnapshot(stores) {
  return JSON.parse(
    jsonStringifySafe({
      appState: stores.appStore.state
    })
  )
}
